module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-551-retro.84e63f1a.jpg";